import { useParams } from "react-router";
import { useUserBookingQuery } from "../../api/bookingApi.ts";
import { usePendingChangeRequestQuery } from "../../api/bookingChangeRequestApi.ts";
import PendingChangeRequest from "../../components/booking/PendingChangeRequest.tsx";
import ChangeRequestHistory from "../../components/booking/ChangeRequestHistory.tsx";
import BookingCard from "../../components/booking/BookingCard.tsx";
import Container from "../../components/Container.tsx";
import ContainerHeader from "../../components/ContainerHeader.tsx";
import BackButton from "../../components/navigation/BackButton.tsx";
import LoadingState from "../../components/LoadingState.tsx";
import ErrorState from "../../components/ErrorState.tsx";
import { Trans } from "@lingui/react/macro";
import { useLingui } from "@lingui/react";
import { useAuth } from "react-oidc-context";

const BookingDetailPage = () => {
  const { i18n } = useLingui();
  const { bookingId } = useParams();
  const auth = useAuth();
  const currentUserId = auth.user?.profile.sub || "";

  const { data: booking, isLoading, isError } = useUserBookingQuery(bookingId);
  const { data: pendingRequest } = usePendingChangeRequestQuery(bookingId);

  if (isLoading) {
    return <LoadingState message={i18n._("Loading booking...")} />;
  }

  if (isError || !booking) {
    return <ErrorState />;
  }

  const isBooker = booking.bookerId === currentUserId;

  return (
    <main className="flex w-full items-center justify-center px-4 pt-4">
      <Container className="max-w-2xl min-w-1/2">
        <BackButton
          to={isBooker ? "/mystudio/bookings" : "/mystudio/teacher-dashboard"}
          label={i18n._("Back to Bookings")}
        />
        <ContainerHeader>
          <Trans>Booking Details</Trans>
        </ContainerHeader>

        <div className="space-y-6">
          <BookingCard
            booking={booking}
            showTeacher={booking.bookerId === currentUserId}
            movable={booking.status === "BOOKED"}
            cancellable={
              booking.status === "BOOKED" && booking.bookerId === currentUserId
            }
          />

          {pendingRequest && (
            <PendingChangeRequest
              changeRequest={pendingRequest}
              bookingId={booking.id}
              currentUserId={currentUserId}
            />
          )}

          <ChangeRequestHistory bookingId={booking.id} />
        </div>
      </Container>
    </main>
  );
};

export default BookingDetailPage;
